export const REQUEST_DEMO_PATH = '/request-demo'
